import React from 'react'
import { useHistory } from 'react-router-dom'
import { AddOutline } from 'antd-mobile-icons'
import AppList from './AppList'
import { getParameterByName } from '../../components/common/utils'
import { useIssueCertsList } from '../../services/hooks'

export default function IssueCertsListPage() {
  const type = getParameterByName('type')
  const { push } = useHistory()

  const { data, loading, pagination } = useIssueCertsList()

  if (!type) return null
  return (
    <AppList
      data={data?.list || []}
      detailUrl={`/issue_certs/detail?type=${type}`}
      pagination={pagination}
      title={'issue-certs-efrp-name'}
      rightContent={<AddOutline fontSize={20} onClick={() => push(`/issue_certs/new?type=${type}`)} />}
      loading={loading}
    />
  )
}
